import createWsAction from 'utils/create-ws-action'

// ------------------------------------
// Action Types
// ------------------------------------
export const AGENT_LIST_FETCH = 'unifi.AGENT_LIST_FETCH'
export const AGENT_CREATE = 'unifi.AGENT_CREATE'

// ------------------------------------
// Action Creators
// ------------------------------------
export const listAllAgents = createWsAction({
    type: AGENT_LIST_FETCH,
    messageType: 'core.site-management.list-all-configured-agents',
    selectorKey: 'agentList',
    fields: ['clientId']
})

export const createAgent = createWsAction({
    type: AGENT_CREATE,
    messageType: 'core.site-management.create-agent',
    selectorKey: 'agentDetail',
    fields: ['clientId', 'agentId', 'intervalSeconds'],
});

export default null



// WEBPACK FOOTER //
// ./src/redux/modules/model/agent.js